import {Util} from "./Util.mjs";
import {TAGS} from "./GlobalStatics.mjs";
import Konva from "konva"

type PresenterParams = {presenterLayer:Konva.Layer, offset:{x:number,y:number}, size:{width:number, height:number}};
type PresenterCreationFunc = (Width: number, Height: number, Depth:number,  isMobile: boolean, bgColor:string) => PresenterParams | Promise<PresenterParams>;
export const PredefinedPresenters: Record<string,PresenterCreationFunc> = {
    Page: function (pageWidth: number, pageHeight: number, depth:number = 0, isMobile: boolean = false, bgColor:string):PresenterParams {
        const margin = Util.universalStandardUnits(8/2, pageWidth, pageHeight);
        const layer = new Konva.Layer({
            id: TAGS.PRESENTER_LAYER,
            presenterType: "Page",
            listening: false,
            imageSmoothingEnabled: false
        });
        const passePartout = new Konva.Rect({
            id: TAGS.PASSE_PARTOUT,
            x: - margin,
            y: - margin,
            width: pageWidth + 2*margin,
            height: pageHeight + 2*margin,
            fill: bgColor
        });
        layer.add(passePartout);
        const shadow = new Konva.Rect({
            name: "backgroundShadow",
            x: 1,//--> zapobiega widoczności mikro-pikseli na krawędziach
            y: 1,
            width: pageWidth - 2, //--> zapobiega widoczności mikro-pikseli na krawędziach
            height: pageHeight - 2,
            fill: "gray",
            shadowColor: `rgba(0,0,0,${isMobile ? 0.20 : 0.25})`,
            shadowBlur: Util.universalStandardUnits(3, pageWidth, pageHeight),
            shadowOffsetX: Util.universalStandardUnits(0.5, pageWidth, pageHeight),
            shadowOffsetY: Util.universalStandardUnits(0.5, pageWidth, pageHeight),
            shadowForStrokeEnabled: false,
            fillAfterStrokeEnabled: false,
            perfectDrawEnabled: false
        });
        layer.add(shadow);
        const hole = new Konva.Rect({
            name: "backgroundHole",
            width: pageWidth,
            height: pageHeight,
            fill: "red",
            globalCompositeOperation: "destination-out",
            perfectDrawEnabled: false
        });
        layer.add(hole);
        return {presenterLayer: layer,
                offset:passePartout.position(),
                size:passePartout.size()};
    },
    Strip: function(pageWidth: number, pageHeight: any, depth:number=0, isMobile: boolean = false, bgColor:string): PresenterParams {
        const params = PredefinedPresenters.Page(pageWidth, pageHeight,depth, isMobile, bgColor) as PresenterParams;
        params.presenterLayer.setAttrs({
            presenterType: "Strip"
        });
        const dashWidth = Util.universalStandardUnits(1.1, pageWidth, pageHeight);
        const separator = new Konva.Line({
            points: [pageWidth / 2, 0, pageWidth / 2, pageHeight],
            stroke: "black",
            opacity: 0.27,
            strokeWidth: Util.universalStandardUnits(0.25,pageWidth,pageHeight),
            dash: [dashWidth, dashWidth],
            name: "midSeparator"
        });
        params.presenterLayer.add(separator);
        return params;
    },
    Canvas: function (productWidth: number, productHeight: number, productDepth:number):PresenterParams {
        //#region Przygotowanie kształtu rozłożonego pudełka
        productDepth = 200; //TEST
        const productInnerWidth = productWidth - 2 * productDepth;
        const productInnerHeight = productHeight - 2 * productDepth;
        const toString = (n: { x:number,y:number }) => { return `${n.x} ${n.y}` };
        const innerPointTopLeft = { x: productDepth, y: productDepth };
        const innerPointTopRight = { x: productInnerWidth + productDepth, y: productDepth };
        const innerPointBottomRight = { x: productInnerWidth + productDepth, y: productInnerHeight + productDepth };
        const innerPointBottomLeft = { x: productDepth, y: productInnerHeight + productDepth };
        const outerPointTopLeftTopWing = { x: productDepth, y: 0 };
        const outerPointTopLeftSideWing = { x: 0, y: productDepth };
        const outerPointTopRightTopWing = { x: productInnerWidth + productDepth, y: 0 };
        const outerPointTopRightSideWing = { x: productInnerWidth + 2 * productDepth, y: productDepth };
        const outerPointBottomRightTopWing = { x: productInnerWidth + productDepth, y: productInnerHeight + 2 * productDepth };
        const outerPointBottomRightSideWing = { x: productInnerWidth + 2 * productDepth, y: productInnerHeight + productDepth };
        const outerPointBottomLeftTopWing = { x: productDepth, y: productInnerHeight + 2 * productDepth };
        const outerPointBottomLeftSideWing = { x: 0, y: productInnerHeight + productDepth };
        const svgPath = `M ${toString(innerPointTopLeft)} L ${toString(outerPointTopLeftTopWing)} ${toString(outerPointTopRightTopWing)} ${toString(innerPointTopRight)} ${toString(outerPointTopRightSideWing)} ${toString(outerPointBottomRightSideWing)} ${toString(innerPointBottomRight)} ${toString(outerPointBottomRightTopWing)} ${toString(outerPointBottomLeftTopWing)} ${toString(innerPointBottomLeft)} ${toString(outerPointBottomLeftSideWing)} ${toString(outerPointTopLeftSideWing)}Z`;
        //#endregion

        const borderWidth = Util.universalStandardUnits(1, productWidth, productHeight); // *2 ponieważ obramowanie będzie podspodem
        const offset = (borderWidth/2);

        const layer = new Konva.Layer({
            id: TAGS.PRESENTER_LAYER,
            presenterType: "Canvas",
            listening: false,
            imageSmoothingEnabled: false
        });
        const passePartout = new Konva.Rect({
            id: TAGS.PASSE_PARTOUT,
            x: - offset,
            y: - offset,
            width: productWidth + borderWidth,
            height: productHeight + borderWidth,
            fill: "white",
            opacity:0.5
        });
        layer.add(passePartout);
        const border = new Konva.Path({
            name: "backgroundBorder",
            data: svgPath,
            fill: "transparent",
            stroke: "red",
            strokeWidth: borderWidth,
            shadowForStrokeEnabled: false,
            fillAfterStrokeEnabled: false,
            perfectDrawEnabled: false
        });
        layer.add(border);
        /*const hole = new Konva.Path({
            name: "backgroundHole",
            data: svgPath,
            fill: "red",
            globalCompositeOperation: "destination-out",
            perfectDrawEnabled: false
        });*/
        const hole = new Konva.Rect({
            name: "backgroundHole",
            position: innerPointTopLeft,
            width:productInnerWidth,
            height:productInnerHeight,
            fill: "red",
            globalCompositeOperation: "destination-out",
            perfectDrawEnabled: false
        });
        layer.add(hole);
        const dashWidth = Util.universalStandardUnits(1.1, productWidth, productHeight);
        const dashRect = new Konva.Rect({
            position: innerPointTopLeft,
            width:productInnerWidth,
            height:productInnerHeight,
            stroke: "black",
            opacity: 0.27,
            strokeWidth: Util.universalStandardUnits(0.25, productWidth, productHeight),
            dash: [dashWidth, dashWidth],
            perfectDrawEnabled: false
        });
        layer.add(dashRect);
        return {
            presenterLayer:layer,
            offset:passePartout.position(),
            size:passePartout.size()
        };

    },
    Mug: async function (productWidth: number, productHeight: number, depth:number=0, isMobile:boolean = false, bgColor:string): Promise<PresenterParams> {
        const margin = Util.universalStandardUnits(10/2, productWidth, productHeight);
        const layer = new Konva.Layer({
            id: TAGS.PRESENTER_LAYER,
            presenterType: "Mug",
            listening: false,
            imageSmoothingEnabled: true
        });
        const mugImg:Konva.Image = await new Promise((resolve, reject)=>{
            Konva.Image.fromURL("_content/PixelTech.Konva/image/mug3.png", (img) => { resolve(img); })});

        const initH = 0.812* mugImg.height(); //original 0.731
        const scale = productHeight/initH;
        const imgH = mugImg.height() * scale; 
        const imgW = mugImg.width() * scale;
        const inMugW = 0.634 * imgW; //original 0.634
        const inMugY = 0.114 * imgH; //original 0.154
        const outMugX = productWidth - inMugW;

        const passePartout = new Konva.Rect({
            id: TAGS.PASSE_PARTOUT,
            y: - (margin+inMugY),
            x: - margin,
            width: outMugX + imgW + 2*margin,
            height: imgH + 2*margin,
            fill: bgColor
        });
        layer.add(passePartout);
        
        mugImg.setAttrs({
            x: outMugX,
            y: -inMugY,
            scaleX: scale,
            scaleY: scale,
        });
        layer.add(mugImg);
        
        /*(const shadow = new Konva.Rect({
            name: "backgroundShadow",
            x: 1,//--> zapobiega widoczności mikro-pikseli na krawędziach
            y: 1,
            width: productWidth - 2, //--> zapobiega widoczności mikro-pikseli na krawędziach
            height: productHeight - 2,
            fill: "gray",
            shadowColor: `rgba(0,0,0,${isMobile ? 0.14 : 0.19})`,
            shadowBlur: Util.universalStandardUnits(3, productWidth, productHeight),
            shadowOffsetX: - Util.universalStandardUnits(2.5, productWidth, productHeight),
            shadowOffsetY: Util.universalStandardUnits(1.1, productWidth, productHeight),
            shadowForStrokeEnabled: false,
            fillAfterStrokeEnabled: false,
            perfectDrawEnabled: false
        });
        layer.add(shadow);*/
        
        const hole = new Konva.Rect({
            name: "backgroundHole",
            width: productWidth,
            height: productHeight,
            fill: "red",
            globalCompositeOperation: "destination-out",
            perfectDrawEnabled: false
        });
        layer.add(hole);
        return {
            presenterLayer:layer,
            offset:passePartout.position(),
            size:passePartout.size()
        };
    }
}